module.exports = __webpack_public_path__ + "img/2.7ec46dd0.png";